/* src/app/promo-plan/promo-plan-upload/promo-plan-upload.component.css */
.promo-plan-upload-container {
  padding: 1rem;
}
.excel-columns-guide {
  background-color: #f9f9f9;
  border: 1px solid #e0e0e0;
  padding: 15px;
  border-radius: 4px;
  margin-bottom: 20px;
  max-height: 200px;
  overflow-y: auto;
}
.excel-columns-guide ol {
  margin: 0;
  padding-left: 20px;
}
.excel-columns-guide li {
  margin-bottom: 5px;
  font-size: 0.9em;
}
:host ::ng-deep .p-fileupload-basic .p-button {
  margin-right: 0.5rem;
}
.card {
  padding: 1rem;
  border-radius: 8px;
  box-shadow: 0 2px 4px rgba(0, 0, 0, 0.1);
}
:host ::ng-deep .p-datatable-scrollable .p-datatable-thead > tr > th {
  position: sticky;
  top: 0;
  z-index: 1;
}
/*# sourceMappingURL=promo-plan-upload.component-G7WDOARI.css.map */
